import React, { Component } from 'react';
import {
  Field,
  reduxForm,
  getFormValues,
  getFormSyncErrors,
  change,
} from 'redux-form';
import PropTypes from 'prop-types';
import { Grid, Form, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { InputField, CheckboxField, SelectField } from 'Common/SemanticWrapper';
import { ControlInfoEnum } from 'Common/FieldEnum';
import { InputMode } from 'Common/FormEnum';
import { DISTRICT_SETTINGS_FORM_NAME } from 'Common/FormEnum';
import { makeOptionsData } from 'Common/FormHelper';

import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { TitledCard, ValidationBanner } from 'Components';
import { Main } from 'Containers';

import * as DistrictInfoSelector from '../state/districtInfo/selectors';

import 'PageStyles/controlinfo/index.less';

let timeZone = [];

class DistrictSettingsForm extends Component {
  static propTypes = {
    mainProps: PropTypes.object.isRequired,
    formValues: PropTypes.object,
    syncErrors: PropTypes.object,
    invAppEnabled: PropTypes.bool,
    dispatch: PropTypes.func,
    handleEnableMobileInventoryCheckbox: PropTypes.func,
    mobileInventoryLicenseData: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.object,
    ]),
    fetchingMobileSync: PropTypes.bool,
    handleMobileSync: PropTypes.func,
  };

  static defaultProps = {
    formValues: {},
    syncErrors: {},
    mobileInventoryLicenseData: 0,
    dispatch: () => {},
    handleEnableMobileInventoryCheckbox: () => {},
    fetchingMobileSync: false,
    handleMobileSync: () => {},
    invAppEnabled: false,
  };

  state = {
    timeZonesData: false,
  };

  componentDidUpdate(prevProps, prevState) {
    const { timeZones, formValues, change, initialValues } = this.props;

    if (this.state.timeZonesData === false && this.props.timeZones) {
      timeZone = timeZones
        ? makeOptionsData(
            timeZones,
            {
              keyKey: 'Id',
              valueKey: 'Id',
              textKeys: ['Name'],
            },
            zone => zone
          )
        : [];

      this.setState({ timeZonesData: true });
    }

    if (
      !formValues[ControlInfoEnum.ServingNum] &&
      formValues[ControlInfoEnum.StartsWith].length === 0
    ) {
      change(
        DISTRICT_SETTINGS_FORM_NAME,
        ControlInfoEnum.StartsWith,
        initialValues[ControlInfoEnum.StartsWith]
      );
    }
  }

  provisionTypeOptions = [
    { value: '1', label: 'CEP/Provision 2 Only ' },
    { value: '2', label: 'Traditional' },
    { value: '0', label: 'Both' },
  ];

  servingNumberOptions = [
    { value: false, label: 'Same as Student Number' },
    { value: true, label: 'System Generated' },
  ];

  yesNoOptions = [{ value: true, label: 'Yes' }, { value: false, label: 'No' }];

  render() {
    const {
      dispatch,
      formValues,
      syncErrors,
      mainProps,      
      hide,
    } = this.props;
    return (
      <div className={classNames({ hide: hide })}>
        <Main {...mainProps}>
          <ValidationBanner errors={syncErrors} />
          <section className="student-form-component">
            <Form onSubmit={this.props.handleSubmit}>
              <TitledCard title={'Serving Settings'}>
                <Grid style={{ paddingBottom: '20px' }}>
                  <Grid.Row style={{ paddingBottom: '0px' }}>
                    <Grid.Column>
                      {' '}
                      <label>Serving Numbers</label>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={4}>
                    <ReduxFormButtonGroup
                      className={'control-info--form-btn-group'}
                      dispatch={dispatch}
                      formName={DISTRICT_SETTINGS_FORM_NAME}
                      fieldName={ControlInfoEnum.ServingNum}
                      value={formValues[ControlInfoEnum.ServingNum]}
                      options={this.servingNumberOptions}
                    />
                    {formValues[ControlInfoEnum.ServingNum] && (
                      <Grid.Column width={5}>
                        <label>Starts With:</label>
                      </Grid.Column>
                    )}
                    {formValues[ControlInfoEnum.ServingNum] && (
                      <Grid.Column width={3}>
                        <Field
                          name={ControlInfoEnum.StartsWith}
                          component={InputField}
                          type="text"
                          maxLength={12}
                          label={' '}
                          mode={InputMode.Integer}
                        />
                      </Grid.Column>
                    )}
                  </Grid.Row>
                  <Grid.Row
                    columns={2}
                    style={{ paddingTop: '0px', paddingBottom: '0px' }}
                  >
                    <Grid.Column width={5}>
                      <label>District Attendance Factor:</label>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Field
                        name={ControlInfoEnum.AttendanceFactor}
                        component={InputField}
                        type="text"
                        label={' '}
                        maxLength={6}
                        iconPosition={'right'}
                        icon={<Icon name="percent" />}
                        mode={InputMode.Decimal}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row style={{ paddingTop: '0px' }}>
                    <Grid.Column>
                      {' '}
                      <label>Message Options on Serve Screen</label>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Column
                    width={10}
                    style={{ paddingTop: '0px', paddingBottom: '0px' }}
                  >
                    <Field
                      name={ControlInfoEnum.SpecialMessage}
                      component={CheckboxField}
                      label={'Cashier MUST confirm special messages'}
                    />
                    <Field
                      name={ControlInfoEnum.Allergens}
                      component={CheckboxField}
                      label={'Cashier MUST confirm allergens'}
                    />
                  </Grid.Column>
                </Grid>
              </TitledCard>
              <TitledCard title={'Misc Settings'}>
                <Grid>
                  <Grid.Row style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                    <Grid.Column width={8}>
                      <Field
                        name={ControlInfoEnum.TimeZone}
                        component={SelectField}
                        options={timeZone}
                        label={'Time Zone'}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <label>Provision Type Default:</label>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row
                    columns={3}
                    style={{ paddingTop: '0px', paddingBottom: '0px' }}
                  >
                    <ReduxFormButtonGroup
                      className={'control-info--form-btn-group'}
                      dispatch={dispatch}
                      formName={DISTRICT_SETTINGS_FORM_NAME}
                      fieldName={ControlInfoEnum.ProvisionType}
                      value={formValues[ControlInfoEnum.ProvisionType]}
                      options={this.provisionTypeOptions}
                    />
                  </Grid.Row>
                  <Grid.Row
                    columns={3}
                    style={{ paddingTop: '0px', paddingBottom: '0px' }}
                  >
                    <Grid.Column>
                      <label>Enable K12PaymentCenter.com?</label>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2} style={{ paddingBottom: '0px' }}>
                    <ReduxFormButtonGroup
                      className={'control-info--form-btn-group'}
                      dispatch={dispatch}
                      formName={DISTRICT_SETTINGS_FORM_NAME}
                      fieldName={ControlInfoEnum.EnableLPP}
                      value={formValues[ControlInfoEnum.EnableLPP]}
                      options={this.yesNoOptions}
                    />
                  </Grid.Row>
                </Grid>
              </TitledCard>
              <TitledCard title={'Free and Reduced Settings'}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <Field
                        name={ControlInfoEnum.ReprocessTransactions}
                        component={CheckboxField}
                        label={'Reprocess Transactions'}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <label>Determine scanned duplicate application by:</label>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Grid>
                        <Grid.Row
                          columns={3}
                          style={{ paddingTop: '0px', paddingBottom: '0px' }}
                        >
                          <Grid.Column width={2}>
                            <label>Household:</label>
                          </Grid.Column>

                          <Grid.Column style={{ marginTop: '15px' }}>
                            <Field
                              name={ControlInfoEnum.HHName}
                              component={CheckboxField}
                              label={'Last Name, First Name'}
                            />
                          </Grid.Column>
                          <Grid.Column style={{ marginTop: '15px' }}>
                            <Field
                              name={ControlInfoEnum.HHSsn}
                              component={CheckboxField}
                              label={'SSN'}
                            />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Grid>
                        <Grid.Row
                          columns={3}
                          style={{ paddingTop: '0px', paddingBottom: '0px' }}
                        >
                          <Grid.Column width={2}>
                            <label>Student:</label>
                          </Grid.Column>

                          <Grid.Column style={{ marginTop: '15px' }}>
                            <Field
                              name={ControlInfoEnum.CaseNumber}
                              component={CheckboxField}
                              label={'Case Number'}
                            />
                          </Grid.Column>
                          <Grid.Column style={{ marginTop: '15px' }}>
                            <Field
                              name={ControlInfoEnum.StudentSsn}
                              component={CheckboxField}
                              label={'SSN'}
                            />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row
                    columns={3}
                    style={{ paddingTop: '0px', paddingBottom: '0px' }}
                  >
                    <Grid.Column>
                      <label>Second Review Required?</label>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2} style={{ paddingBottom: '0px' }}>
                    <ReduxFormButtonGroup
                      className={'control-info--form-btn-group'}
                      dispatch={dispatch}
                      formName={DISTRICT_SETTINGS_FORM_NAME}
                      fieldName={ControlInfoEnum.RequireSecondReview}
                      value={formValues[ControlInfoEnum.RequireSecondReview]}
                      options={this.yesNoOptions}
                    />
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <label>Release Categories:</label>
                    </Grid.Column>
                  </Grid.Row>
                  {[...Array(9)].map((x, i) => {
                    return (
                      <Grid.Row
                        style={{ paddingTop: '0px', paddingBottom: '0px' }}
                        key={i}
                      >
                        <Grid.Column width={8}>
                          <Field
                            name={
                              ControlInfoEnum['Category' + (i + 1).toString()]
                            }
                            component={InputField}
                            type="text"
                            maxLength={30}
                            label={' '}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    );
                  })}
                </Grid>
              </TitledCard>
            </Form>
          </section>
        </Main>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues(DISTRICT_SETTINGS_FORM_NAME)(state),
    syncErrors: getFormSyncErrors(DISTRICT_SETTINGS_FORM_NAME)(state),
    invAppEnabled: DistrictInfoSelector.getInvAppEnabled(state),
    mobileInventoryLicenseData: DistrictInfoSelector.getMobileInventoryLicenseData(
      state
    ),
    fetchingMobileSync: DistrictInfoSelector.getFetchingMobileSync(state),
  };
};

DistrictSettingsForm = connect(
  mapStateToProps,
  { change }
)(DistrictSettingsForm);

const validate = (values, props) => {
  const errors = {};
  if (
    !values[ControlInfoEnum.StartsWith] ||
    values[ControlInfoEnum.StartsWith].length === 0
  ) {
    errors[ControlInfoEnum.StartsWith] = 'Starts With value required.';
  }

  return errors;
};

export default reduxForm({
  validate,
  form: DISTRICT_SETTINGS_FORM_NAME,
  destroyOnUnmount: false,
})(DistrictSettingsForm);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/DistrictSettingsForm.js